import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

if (environment.production) {
    enableProdMode();
}

document.addEventListener(`DOMContentLoaded`, () => {
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err) => {
            return console.error(err);
        });
});
